export class AdminUserAuthConstants {
  static readonly PaymeUser = class {
    static readonly List: string = 'PaymeUser.List';
    static readonly L1Approve: string = "Verification.Level1.Approve";
    static readonly L1Reject: string = "Verification.Level1.Reject";
    static readonly L1Update: string = "Verification.Level1.Update";
    static readonly L2Approve: string = "Verification.Level2.Approve"
    static readonly L2Reject: string = "Verification.Level2.Reject";
    static readonly L2Update: string = "Verification.Level2.Update";
    static readonly L2PensionUpdate: string = "Verification.Level2.UpdatePension";
    static readonly PDL1Approve: string = "Verification.PDLevel1.Approve";
    static readonly PDL1Reject: string = "Verification.PDLevel1.Reject";
    static readonly PDL1Update: string = "Verification.PDLevel1.Update";
    static readonly VerificationUploadAttachment: string = "Verification.UploadAttachment";
    static readonly KYCAndPensionUpdate: string = "Pensioner.InformationUpdate";
    static readonly PDL2Approve: string = "Verification.PDLevel2.Approve";
    static readonly PDL2Reject: string = "Verification.PDLevel2.Reject";
    static readonly PDL2Update: string = "Verification.PDLevel2.Update";
    static readonly VerificationUserUpdate: string = "Verification.User.Update";
    static readonly PDOfficer: string = 'PaymeUser.PDOfficer';
    static readonly L1PDOfficer: string = 'PaymeUser.L1PDOfficer';
    static readonly L2PDOfficer: string = 'PaymeUser.L2PDOfficer';
    static readonly AgentVerification: string = 'PaymeUser.AgentVerification';

    static readonly AgentVerificationL1Approve: string = "FOSAgent.Level1.Approve";
    static readonly AgentVerificationL1Reject: string = "FOSAgent.Level1.Reject";
    static readonly AgentVerificationL1Update: string = "FOSAgent.Level1.Update";
    static readonly AgentVerificationL2Approve: string = "FOSAgent.Level2.Approve";
    static readonly AgentVerificationL2Reject: string = "FOSAgent.Level2.Reject";
    static readonly AgentVerificationL2Update: string = "FOSAgent.Level2.Update";
    static readonly AgentVerificationL3Approve: string = "FOSAgent.Level3.Approve";
    static readonly AgentVerificationL3Reject: string = "FOSAgent.Level3.Reject";
    static readonly AgentVerificationL3Update: string = "FOSAgent.Level3.Update";

    // static readonly L2PDOfficer: string = 'PaymeUser.PDOfficer';
  };

  static readonly Dashboard = class {
    static readonly DashboardView: string = "Dashboard";
  }

  static readonly Pension = class {
    static readonly List: string = 'Pension.List';
    static readonly ImportedList: string = 'Pension.ImportedList';
    static readonly Approve: string = 'Pension.Approve';
    static readonly Update: string = 'Pension.Update';
    static readonly Reject: string = 'Pension.Reject';
    static readonly L1Verification: string = 'Pension.L1Verification';
    static readonly L2Verification: string = 'Pension.L2Verification';
    static readonly PDOfficer: string = 'Pension.PDOfficer';
  };

  static readonly BatchFile = class {
    static readonly List: string = 'BatchFile.List';
    static readonly Detail: string = 'BatchFile.Detail';
    static readonly Upload: string = 'BatchFile.Upload';
  };

  static readonly Agent = class {
    static readonly List: string = 'Agent.List';
    static readonly Create: string = 'Agent.Create';
    static readonly Update: string = 'Agent.Update';
    static readonly Unblock: string = 'Agent.Unblock';
    static readonly CreateOrUpdate: string = '';
    static readonly ActiveAgent: string = 'FOSAgent.AgentList';
  };

  static readonly AgentManagement = class {
    static readonly Onboarding: string = 'Agent.Onboarding';
    static readonly CashRequestCreate: string = "CashRequest.Request";
    static readonly CashReturnCreate: string = "CashReturn.Create";
    static readonly CashRequestApprove: string = "CashRequest.Approve";
    static readonly CashRequestReject: string = "CashRequest.Reject";
    static readonly CashRequestReconcile: string = "CashRequest.Reconcile";
    static readonly CashRequestClose: string = "CashRequest.Close";
    // static readonly Update: string = 'Agent.Update';
    // static readonly Unblock: string = 'Agent.Unblock';
    // static readonly CreateOrUpdate: string = '';
  };

  static readonly AgentRole = class {
    static readonly List: string = 'AgentRole.List';
    static readonly Create: string = 'AgentRole.Create';
    static readonly Update: string = 'AgentRole.Update';
    static readonly Delete: string = 'AgentRole.Delete';
  };

  static readonly ServiceRequest = class {
    static readonly List: string = 'ServiceRequest.List';
    static readonly Create: string = 'ServiceRequest.Create';
    static readonly Assign: string = 'ServiceRequest.Assign';
  };

  static readonly ChangeRequest = class {
    static readonly List: string = 'ChangeRequest.List';
    static readonly Create: string = 'ChangeRequest.Create';
    static readonly Approve: string = 'ChangeRequest.Approve';
    static readonly Reject: string = 'ChangeRequest.Reject';
  };

  static readonly AdminUser = class {
    static readonly List: string = 'AdminUser.List';
    static readonly Create: string = 'AdminUser.Create';
    static readonly Update: string = 'AdminUser.Update';
    static readonly Delete: string = 'AdminUser.Delete';
    static readonly FOSAgentResetPassword: string = 'Admin.ResetPassword';
  };

  static readonly AdminRole = class {
    static readonly List: string = 'AdminRole.List';
    static readonly Create: string = 'AdminRole.Create';
    static readonly Update: string = 'AdminRole.Update';
    static readonly Delete: string = 'AdminRole.Delete';
  };

  static readonly Ministry = class {
    static readonly List: string = 'Ministry.List';
    static readonly Create: string = 'Ministry.Create';
    static readonly Update: string = 'Ministry.Update';
    static readonly Delete: string = 'Ministry.Delete';
  };

  static readonly Department = class {
    static readonly List: string = 'Department.List';
    static readonly Create: string = 'Department.Create';
    static readonly Update: string = 'Department.Update';
    static readonly Delete: string = 'Department.Delete';
  };

  static readonly Region = class {
    static readonly List: string = 'Region.List';
    static readonly Create: string = 'Region.Create';
    static readonly Update: string = 'Region.Update';
    static readonly Delete: string = 'Region.Delete';
  };

  static readonly CashCollection = class {
    static readonly List: string = 'CashCollection.List';
    static readonly Create: string = 'CashCollection.Create';
    static readonly Update: string = 'CashCollection.Update';
    static readonly Delete: string = 'CashCollection.Delete';
  };

  static readonly FundOut = class {
    static readonly FundOutApprove: string = 'FundOut.Approved';
  };

  static readonly ProxyFile = class {
    static readonly ProxyFileUpload: string = 'ProxyFile.Upload';
    static readonly ProxyFileList: string = 'ProxyFile.List';
  };
}
